import { FC } from 'react';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'next-share';
import { useShareUrl } from '../hooks';
import LinkedinRed from '/public/static/LinkedinRed.svg';
import FacebookRed from '/public/static/FacebookRed.svg';
import TwitterRed from '/public/static/TwitterRed.svg';

interface IShareContainer {
  showTitle?: boolean;
  className?: string;
  title: string;
}

export const ShareContainer: FC<IShareContainer> = ({
  showTitle = false,
  className = '',
  title = '',
}) => {
  const url = useShareUrl();

  return (
    <div className={`h-fit ${className}`}>
      {showTitle && (
        <p className="text-lg leading-[1.375rem] mb-2">
          {process.env.NEXT_PUBLIC_SITE_LANG === 'hu' ? 'Megosztás' : 'Share'}
        </p>
      )}
      <div className="flex justify-between w-[160px]">
        <LinkedinShareButton url={url} title={title}>
          <LinkedinRed width={32} height={32} />
        </LinkedinShareButton>
        <FacebookShareButton url={url} quote={title}>
          <FacebookRed width={32} height={32} />
        </FacebookShareButton>
        <TwitterShareButton url={url} title={title}>
          <TwitterRed width={32} height={32} />
        </TwitterShareButton>
      </div>
    </div>
  );
};
